




import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { WidgetMixin, TextMixin } from "./mixins";

@Component
export default class WCopyright extends Mixins(WidgetMixin, TextMixin) {}
